const BOM = '﻿';
const DELIMITERS = [',', ';', '\t'];

/** The delimiter used by the first non-empty line (outside quotes): comma, semicolon or tab. */
function detectDelimiter(text) {
  const counts = new Map(DELIMITERS.map((d) => [d, 0]));
  let inQuotes = false;
  for (const char of text) {
    if (char === '"') inQuotes = !inQuotes;
    else if (!inQuotes && (char === '\n' || char === '\r')) {
      if ([...counts.values()].some(Boolean)) break;
    } else if (!inQuotes && counts.has(char)) counts.set(char, counts.get(char) + 1);
  }
  const [best, count] = [...counts.entries()].sort((a, b) => b[1] - a[1])[0];
  return count > 0 ? best : ',';
}

/**
 * RFC-4180-ish CSV parser: quoted fields, doubled quotes, CRLF/LF, BOM, and `,` `;` or tab
 * delimiters. Blank lines are KEPT as `['']` rows so row numbers match the spreadsheet.
 *
 * @param {string} input
 * @returns {string[][]}
 */
export function parseCsv(input) {
  const text = input.startsWith(BOM) ? input.slice(1) : input;
  if (!text) return [];

  const delimiter = detectDelimiter(text);
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;

  const endField = () => {
    row.push(field);
    field = '';
  };
  const endRow = () => {
    endField();
    rows.push(row);
    row = [];
  };

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    if (inQuotes) {
      if (char !== '"') field += char;
      else if (text[i + 1] === '"') {
        field += '"';
        i += 1;
      } else inQuotes = false;
    } else if (char === '"') inQuotes = true;
    else if (char === delimiter) endField();
    else if (char === '\n') endRow();
    else if (char === '\r') {
      if (text[i + 1] === '\n') i += 1;
      endRow();
    } else field += char;
  }
  // A final line without a newline still counts; a trailing newline does not add a row.
  if (field !== '' || row.length > 0) endRow();

  return rows;
}
